var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":"650"},model:{value:(_vm.openDialog),callback:function ($$v) {_vm.openDialog=$$v},expression:"openDialog"}},[_c('v-card',{staticClass:"emcomy-card"},[_c('login-form-component',{on:{"closeForm":function($event){return _vm.close()}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }